import React, { useState, useEffect } from 'react';
import { getDomainData, getMoodGridData, getMoodReasonsData } from '../service/api';
import { useLocation, useNavigate } from 'react-router-dom';
import { encryptStorage } from '../constant';

import moment from 'moment';
import MoodAnalytic from './MoodAnalyticGrid';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
// import '../components/css/Dashboard-styles.css'
// import '../components/css/leave-form.css';
import '../components/css/team_mood.css';
import '../components/css/Team-Directory Grid.css';
import BreadCrumbs from './BreadCrumbs/BreadCrumbs';
import Loader from '../StaticComponent/Loader';

const MoodGrid = (filterDates = '') => {

    const navigate = useNavigate();

    const { state } = useLocation();

    const [data, setData] = useState();

    const [domains, setDomains] = useState();

    const [moods, setMoods] = useState();

    const [reasons, setReasons] = useState();

    const [role, setRole] = useState(encryptStorage.getItem('role'));

    const [dates, setDates] = useState();

    const [Domainsorting, setDomainSorting] = useState(true);
    const [Namesorting, setNameSorting] = useState(true);
    const [Datesorting, setDateSorting] = useState(true);

    // const [toggleDate, setToggleDate] = useState({})

    const [showMore, setShowMore] = useState(false);

    const [filterClick, setFilterClick] = useState(false);

    const [limit, setLimit] = useState(10);

    const [toggle, setToggle] = useState();
    const [isLoading, setIsLoading] = useState();

    const gridData = {
        reason: '',
        domain: '',
        mood: '',
        start_date: filterDates ? moment().startOf('month').format('YYYY-MM-DD') : filterDates.start_date,
        end_date: filterDates ? moment().endOf('month').format('YYYY-MM-DD') : filterDates.end_date,
        limit: limit,
    };

    const filterObj = {
        reason: '',
        domain: state?.filterData?.domain || '',
        mood: state?.mood || '',
        start_date: filterDates?.start_date || state?.filterData?.start_date || state?.date?.start_date || '',
        end_date: filterDates?.end_date || state?.filterData?.end_date || state?.date?.end_date || '',
        sortColumn: '',
        sortOrder: '',
        limit: limit,
    };

    const filterAanalyticObj = {
        month: '',
    };

    const [filterData, setFilterData] = useState(filterObj);

    const [analyticFilterData, setAnalyticFilterData] = useState(filterAanalyticObj);

    const infoForShowMore = (countResult, countToDivid) => {
        let count = countResult;

        let result = count / countToDivid;

        setShowMore(result <= 1 ? false : true);
        // setShowMore(countToDivid > limit ? false : true);
    };

    useEffect(() => {

        setRole(encryptStorage.getItem('role'));

        if (encryptStorage.getItem('groupid') == '1' || encryptStorage.getItem('groupid') == '2') {
            fetchApi();
        } else {
            navigate('/', { state: { hideNav: false } });
        }
    }, []);

    const fetchApi = async (data) => {
        try {

            let resp;

            setIsLoading(false);

            if (
                filterData.domain ||
                filterData.reason ||
                filterData.mood ||
                filterData.start_date ||
                filterData.end_date ||
                filterData.sortColumn ||
                data?.sortColumn ||
                data?.sortOrder ||
                data?.limit
            ) {
                resp = await getMoodGridData(data ? data : filterData, role);
            }
            //  else if (state?.filterData && (state.filterData.domain || (state.filterData.start_date && state.filterData.start_date))) {
            //     resp = await getMoodGridData(state.filterData);

            //     state.filterData = {};
            // }
            else {
                resp = await getMoodGridData(gridData, role);
            }

            const domainResp = await getDomainData();

            if (domainResp?.data?.ResponseData.length) setDomains(domainResp.data.ResponseData);

            const moodReasonResp = await getMoodReasonsData();

            if (moodReasonResp?.data?.ResponseData.length > 1) {
                setMoods(moodReasonResp?.data?.ResponseData[0]);

                setReasons(moodReasonResp.data.ResponseData[1]);
            }

            setIsLoading(true);

            if (resp?.data?.ResponseData.length > 1) {
                setData(resp.data.ResponseData[0]);

                infoForShowMore(resp.data.countData, limit);

                setDates(resp.data.ResponseData[1]);
            }
        } catch (err) { }
    };

    const domainMethod = () => {
        try {
            if (role == 'Hr Manager' || role == 'Hr') {
                return (
                    <>
                        <label className="form-label hive-form-label">Domain</label>
                        <select
                            className="form-select hive-form-select"
                            value={filterData.domain}
                            onChange={(e) => {
                                setFilterData((filterData) => ({
                                    ...filterData,
                                    [e.target.name]: e.target.value,
                                }));
                            }}
                            name="domain"
                        >
                            <option selected value="">
                                Select
                            </option>
                            {domains.map((domain) => {
                                try {
                                    return <option value={domain}>{domain}</option>;
                                } catch (err) { }
                            })}
                        </select>
                    </>
                );
            } else {
                return null;
            }
        } catch (e) { }
    };

    const moodMethod = () => {
        try {
            return (
                <>
                    <label className="form-label hive-form-label">Moods</label>
                    <select
                        className="form-select hive-form-select"
                        value={filterData.mood}
                        onChange={(e) => {
                            setFilterData((filterData) => ({
                                ...filterData,
                                [e.target.name]: e.target.value,
                            }));
                        }}
                        name="mood"
                    >
                        <option selected value="">
                            Select
                        </option>
                        {moods.map((mood) => {
                            try {
                                return (
                                    <option style={{ 'text-transform': 'capitalize' }} value={mood.mood_name}>
                                        {mood.mood_name}
                                    </option>
                                );
                            } catch (err) { }
                        })}
                    </select>
                </>
            );
        } catch (e) { }
    };

    const reasonMethod = () => {
        try {
            return (
                <>
                    <label className="form-label hive-form-label">Reasons</label>
                    <select
                        className="form-select hive-form-select"
                        value={filterData.reason}
                        onChange={(e) => {
                            setFilterData((filterData) => ({
                                ...filterData,
                                [e.target.name]: e.target.value,
                            }));
                        }}
                        name="reason"
                    >
                        <option selected value="">
                            Select
                        </option>
                        {reasons.map((reason) => {
                            try {
                                return <option value={reason.name}>{reason.name}</option>;
                            } catch (err) { }
                        })}
                    </select>
                </>
            );
        } catch (e) { }
    };

    const showMoreClick = () => {
        try {

            let val = Number(limit) + 10;

            setLimit(val);

            setFilterData((filterData) => ({ ...filterData, limit: val }));

            let data = filterData;

            data['limit'] = val;

            if (filterClick) fetchApi(data);
            else fetchApi(data);
        } catch (e) { }
    };

    const gridBody = () => {
        try {
            if (data.length == 0) {
                return (
                    <tr>
                        <td colSpan={10}>
                            <div className="row justify-content-center">
                                <img
                                    src="/Images/vadivelu.png"
                                    alt="nodatafound"
                                    className="nofeedbackimg-sty"
                                    style={{ height: '500px', width: '750px' }}
                                />

                                <h2 className="tt-bold font-15 text-center">No Records Found</h2>
                            </div>
                        </td>
                    </tr>
                );
            } else {
                return data.map((datum) => {
                    try {
                        let commentsVar;
                        let nameVar;

                        // function concatu(value, char) {


                        //     if (value.length > 15) {
                        //         this[`${char}`] = value.substring(0, 15)
                        //         this[`${char}`] = this[char] + "..."
                        //     }
                        //     else {

                        //         this[`${char}`] = value
                        //     }

                        // }


                     

                        if (datum.name.length > 15) {
                            nameVar = datum.name.substring(0, 15);
                            nameVar = nameVar + '...';
                        } else {
                            nameVar = datum.name;
                        }

                        if (datum.comments.length > 15) {
                            commentsVar = datum.comments.substring(0, 15);
                            commentsVar = commentsVar + '...';
                        } else {
                            commentsVar = datum.comments;
                        }

                        return (
                            <>
                                <tr className="hive-table-data regular-text align-middle">
                                    <td class="align-items-middle">
                                        <span>
                                            <img
                                                src={
                                                    datum.mood_name == 'happy'
                                                        ? '/Images/HappyEmoji.png'
                                                        : datum.mood_name == 'sad'
                                                            ? '/Images/dashboard-sad.png'
                                                            : '/Images/dashboard-okay.png'
                                                }
                                                className="directory-emoji-class"
                                            />
                                        </span>
                                    </td>
                                    <td>
                                        <div className="d-flex align-items-center">
                                            <img src="/Images/logo-person-user-person-icon.jpg" alt="profile-img" className="table-image" />
                                            <div className="ms-2">
                                                <span href="#" className="table-name-style mb-0">
                                                    {datum.emp_name}
                                                </span>
                                                <p className="table-domain-style mb-0">{datum.domain}</p>
                                            </div>
                                        </div>
                                    </td>
                                    <td>{moment(datum.created_at).format('DD MMM, YYYY')}</td>
                                    {role == 'Hr Manager' || role == 'Hr' ? <td>{datum.domain}</td> : null}
                                    <td title={datum.name}>{nameVar}</td>
                                    <td title={datum.comments}>{commentsVar}</td>
                                </tr>
                            </>
                        );
                    } catch (err) { }
                });
            }
        } catch (err) { }
    };

    const filterClicked = () => {
        try {
            setFilterClick(true);
            fetchApi({ ...filterData, limit: 10 });
            setLimit(10);
        } catch (e) { }
    };

    const sortingFunc = (colName, order) => {
        // //

        setFilterData({ ...filterData, sortColumn: colName, sortOrder: order });

        fetchApi({ ...filterData, sortColumn: colName, sortOrder: order });

        if (colName == 'name') setNameSorting(!Namesorting);
        if (colName == 'date') setDateSorting(!Datesorting);
        if (colName == 'domain') setDomainSorting(!Domainsorting);
    };

    const moodGridToggle = () => {
        try {
            if (!toggle) {
                return (
                    <div className="col-md-12">
                        <div className="tab-content" id="pills-tabContent">
                            {/*All Leave Request Section Starts Here*/}
                            <div
                                className="tab-pane fade show active mt-4"
                                id="all_leave_request"
                                role="tabpanel"
                                aria-labelledby="all_leave_request_tab"
                            >
                                <div className="table-responsive rounded-3">
                                    <table className="table bg-white hive-grid table-borderless ">
                                        <thead className="hive-table-head ">
                                            <tr>
                                                <th className="bold-text font-12">Moods</th>
                                                <th className="bold-text font-12">
                                                    Team Members Name
                                                    <span
                                                        className="ps-2"
                                                        onClick={() => {
                                                            Namesorting ? sortingFunc('name', 'desc') : sortingFunc('name', 'asc');
                                                        }}
                                                    >
                                                        {Namesorting ? (
                                                            <img src="/Images/sort-icon.svg" alt="Sorticon" className="hive-table-sort" />
                                                        ) : (
                                                            <img src="/Images/Sort-up.svg" alt="Sorticon" className="hive-table-sort" />
                                                        )}
                                                    </span>
                                                </th>
                                                <th className="bold-text font-12">
                                                    Date
                                                    <span
                                                        className="ps-2"
                                                        onClick={() => {
                                                            Datesorting ? sortingFunc('date', 'desc') : sortingFunc('date', 'asc');
                                                        }}
                                                    >
                                                        {Datesorting ? (
                                                            <img src="/Images/sort-icon.svg" alt="Sorticon" className="hive-table-sort" />
                                                        ) : (
                                                            <img src="/Images/Sort-up.svg" alt="Sorticon" className="hive-table-sort" />
                                                        )}
                                                    </span>
                                                </th>
                                                {role == 'Hr Manager' || role == 'Hr' ? (
                                                    <th className="bold-text font-12">
                                                        Domain
                                                        <span
                                                            className="ps-2"
                                                            onClick={() => {
                                                                Domainsorting
                                                                    ? sortingFunc('domain', 'desc')
                                                                    : sortingFunc('domain', 'asc');
                                                            }}
                                                        >
                                                            {Domainsorting ? (
                                                                <img
                                                                    src="/Images/sort-icon.svg"
                                                                    alt="Sorticon"
                                                                    className="hive-table-sort"
                                                                />
                                                            ) : (
                                                                <img src="/Images/Sort-up.svg" alt="Sorticon" className="hive-table-sort" />
                                                            )}
                                                        </span>
                                                    </th>
                                                ) : null}
                                                <th className="bold-text font-12">Reasons</th>
                                                <th className="bold-text font-12">Comments</th>
                                            </tr>
                                        </thead>
                                        <tbody>{gridBody()}</tbody>
                                    </table>
                                </div>
                                <div className="text-center">
                                    {showMore ? (
                                        <button
                                            onClick={() => {
                                                showMoreClick();
                                            }}
                                            className="btn show-more-btn"
                                        >
                                            Show More
                                        </button>
                                    ) : null}
                                </div>
                            </div>
                        </div>
                        {/*Tab Content Ends Here*/}
                    </div>
                );
            } else {
                return (
                    <>
                        <MoodAnalytic selectedMonth={analyticFilterData} />
                    </>
                );
            }
        } catch (e) { }
    };

    const toggleClick = (checked) => {
        setToggle(checked);
    };

    let breadCrumbsData = [
        { title: 'Dashboard', path: '/overview', isActive: true },
        { title: 'Team Member', path: '', isActive: true },
        { title: 'Team Mood', path: '/moodgrid', isActive: false },
    ];

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="container-fluid mt-5">
                <div className="row d-flex justify-content-around">
                    <div className="col-md-12 mt-4">
                        <BreadCrumbs data={breadCrumbsData} />
                        <div className="justify-content-between d-flex ">
                            <div>
                                <h1 className="tt-bold-text font-16">Team Mood</h1>
                                <p className="font-12 regular-text">
                                    Mood Swing from{' '}
                                    <span className="blue regular-text font-12" style={{ color: 'rgb(68, 102, 216)' }}>
                                        {analyticFilterData.month && toggle
                                            ? moment(analyticFilterData.month).startOf('month').format('DD MMM, YYYY') +
                                            '-' +
                                            moment(analyticFilterData.month).endOf('month').format('DD MMM, YYYY')
                                            : analyticFilterData.month || toggle
                                                ? moment().startOf('month').format('DD MMM, YYYY') +
                                                '-' +
                                                moment().endOf('month').format('DD MMM, YYYY')
                                                : !toggle
                                                    ? dates
                                                    : null}
                                    </span>
                                </p>
                            </div>
                            <div class="d-flex">
                                <div className="form-check form-switch toggle-style p-0 m-0">
                                    <label className="switch">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                toggleClick(e.target.checked);
                                            }}
                                        />
                                        <span className="slider" />
                                    </label>
                                </div>
                                {!toggle ? (
                                    <div className=" ms-2 dropdown">
                                        <button
                                            className="advanced-filter-button small-button medium-text"
                                            type="button"
                                            id="dropdownMenuButton1"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                        >
                                            <img src="/Images/filter-icon.svg" alt="Filter-icon" className="me-2" />
                                            Filter
                                        </button>
                                        <div
                                            className="dropdown-menu filter-position px-3 advanced-filter-panel"
                                            aria-labelledby="dropdownMenuButton1"
                                        >
                                            <div className="row">
                                                <div className="col-md-12 py-2 border-0 mb-1">
                                                    <span className="font-16 semibold-text advanced-filter-title">Advanced Filter</span>
                                                    <button
                                                        type="button"
                                                        className="btn-close float-end close-filter"
                                                        data-bs-dismiss="advanced-filter"
                                                        aria-label="Close"
                                                    />
                                                </div>
                                                <div className="col-md-12 ">
                                                    <div className="row">
                                                        <div className="col-md-6 ">{reasonMethod()}</div>
                                                        <div className="col-md-6 ">{moodMethod()}</div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6 mb-3">{domainMethod()}</div>
                                                        <h5 className="font-12 bold-text mt-3">Date Range</h5>
                                                        <div className="col-md-6">
                                                            <label className="medium-text font-12 d-flex mb-1">From</label>
                                                            <input
                                                                value={filterData.start_date}
                                                                onChange={(e) => {
                                                                    setFilterData((filterData) => ({
                                                                        ...filterData,
                                                                        ['start_date']: e.target.value,
                                                                    }));
                                                                }}
                                                                max={filterData.end_date}
                                                                type="date"
                                                                name="start_date"
                                                                className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                                                placeholder="Select Domain"
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label className="medium-text font-12 d-flex mb-1">To</label>
                                                            <input
                                                                onChange={(e) => {
                                                                    setFilterData((filterData) => ({
                                                                        ...filterData,
                                                                        ['end_date']: e.target.value,
                                                                    }));
                                                                }}
                                                                min={filterData.start_date}
                                                                value={filterData.end_date}
                                                                type="date"
                                                                name="end_date"
                                                                className="medium-text font-12 dashboard-dropbox-style lable-color2 bold-text p-1"
                                                                placeholder="Select Domain"
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-12 my-3 d-flex justify-content-end">
                                                    <button
                                                        onClick={() => {
                                                            setFilterData({
                                                                ...filterObj,
                                                                domain: '',
                                                                start_date: '',
                                                                end_date: '',
                                                                limit: 10,
                                                            });
                                                            fetchApi({ ...gridData, limit: 10 });
                                                            setShowMore(true);
                                                            setLimit(10);
                                                        }}
                                                        className="btn hive-btn-secondary me-3"
                                                    >
                                                        Clear
                                                    </button>
                                                    <button
                                                        onClick={(e) => {
                                                            filterClicked(e);
                                                        }}
                                                        className="btn hive-btn-primary"
                                                    >
                                                        Apply
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <>
                                        <DatePicker
                                            selected={analyticFilterData.month}
                                            onChange={(e) => {
                                                setAnalyticFilterData((analyticFilterData) => ({
                                                    ...analyticFilterData,

                                                    ['month']: e,
                                                }));
                                            }}
                                            name="month"
                                            dateFormat="MM/yyyy"
                                            showMonthYearPicker
                                            showFullMonthYearPicker
                                            showFourColumnMonthYearPicker
                                            value={analyticFilterData.month}
                                            className="btn btn-secondary dropdown-toggle select-monthly-mood ms-2 blue font-12 medium-text"
                                            placeholderText="Select Month"
                                        />
                                    </>
                                )}
                            </div>
                        </div>

                        {moodGridToggle()}
                    </div>
                </div>
            </div>
        </>
    );
};

export default MoodGrid;
